import { render, staticRenderFns } from "./tabnav.vue?vue&type=template&id=99110d7e&scoped=true"
import script from "./tabnav.vue?vue&type=script&lang=js"
export * from "./tabnav.vue?vue&type=script&lang=js"
import style0 from "./tabnav.vue?vue&type=style&index=0&id=99110d7e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99110d7e",
  null
  
)

export default component.exports